module.exports = function() {
    if (document.getElementsByClassName('cycle-words')[0]) {

        var cycleArr = [];

        var currentIndex = 0;

        var cycleNodes = document.querySelectorAll('.cycle-word');

        for (var i = -1, l = cycleNodes.length >>> 0; ++i !== l; cycleArr[i] = cycleNodes[i]);

        function cycleWords() {

            TweenMax.to(jQuery(cycleArr[currentIndex]), 0.5, {
                autoAlpha: 1,
                display: 'block',
                onComplete: function () {

                    TweenMax.to(jQuery(this.target), 0.5, {
                        delay: 4,
                        autoAlpha: 0,
                        display: 'none',
                        onComplete: function () {

                            currentIndex = ++currentIndex % cycleArr.length;

                            cycleWords();

                        }
                    });

                }
            });

        }

        cycleWords();

        setTimeout(function() {

                jQuery(".hero-cycle-container").addClass('active');

            },
            2000);
    }
};